import React, { useEffect, useState } from 'react'
import Copier from './components/Copier'
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from '../../reducers/common.reducer';
import { getWinLossAllGameTypeByDateService } from '../../services/winloss.service';
import { TbCreditCard } from 'react-icons/tb';

const ProfitSharingForAll = () => {
    const [isSaveFormVisible, setIsSaveFormVisible] = useState(false)
    const [resultData, setResultData] = useState([]);
    const [gameTypeDetailData, setGameTypeDetailData] = useState({});

    const today = new Date();
    const lastWeek = new Date(new Date().setDate(today.getDate() - 7));
    const [startDate, setStartDate] = useState(lastWeek.toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(today.toISOString().split('T')[0]);

    const dispatch = useDispatch();

    const getWinLossForAllGameTypeResult = async () => {
        try {
            dispatch(setIsLoading(true));
            let result = await getWinLossAllGameTypeByDateService({ startDate, endDate });
            if (result.data) {
                setResultData(result.data);
            }
        } catch (error) {
            dispatch(setToastMessage({ message: error?.message, type: "error" }));
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    useEffect(() => {
        getWinLossForAllGameTypeResult();
    }, [startDate, endDate]);

    const totalWinLoss = resultData?.reduce((acc, agent) => acc + (1 * agent.total), 0);

    return (
        <div className='h-[90vh] overflow-y-auto bg-[#F0F2F5] p-2 font-sans text-slate-900' onClick={() => setIsSaveFormVisible(false)}>
            <div className='max-w-5xl mx-auto'>
                
                {/* 1. Header & Quick Summary (အရေးကြီးဆုံးအပိုင်းကို အပေါ်တင်ထားပါတယ်) */}
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-2">
                    <div>
                        <div className="flex items-center gap-2 text-xs font-bold text-blue-600 uppercase tracking-[0.2em]">
                            <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></div>
                            Live Report
                        </div>
                        <h1 className='text-2xl font-black tracking-tight text-slate-800'>Profit Sharing</h1>
                    </div>

                    <div className="bg-white px-8 py-2 rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.04)] border border-white flex items-center gap-8">
                        <div>
                            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Total Win/Loss</p>
                            <p className={`text-xl font-black ${totalWinLoss >= 0 ? 'text-emerald-600' : 'text-red'}`}>
                                {totalWinLoss?.toLocaleString()} <span className="text-xs font-medium text-slate-400">KS</span>
                            </p>
                        </div>
                        <div className="h-10 w-[1px] bg-slate-100"></div>
                        <div>
                            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Items</p>
                            <p className="text-xl font-black text-slate-800">{resultData.length}</p>
                        </div>
                    </div>
                </div>

                {/* 2. Date Filter Bar (ရှင်းလင်းသော Filter အပိုင်း) */}
                <div className="bg-white/60 backdrop-blur-md p-3 rounded-xl border border-white/50 mb-2 flex flex-wrap items-center gap-3">
                    <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} 
                        className='bg-white border border-slate-200 rounded-xl px-4 py-2 text-sm font-semibold focus:ring-2 focus:ring-blue-500 outline-none transition-all' />
                    <span className="text-slate-400">to</span>
                    <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} 
                        className='bg-white border border-slate-200 rounded-xl px-4 py-2 text-sm font-semibold focus:ring-2 focus:ring-blue-500 outline-none transition-all' />
                    
                    <button onClick={getWinLossForAllGameTypeResult} className="ml-auto bg-slate-800 hover:bg-black text-white px-5 py-2 rounded-xl text-xs font-bold transition-all active:scale-95">
                        Refresh Data
                    </button>
                </div>

                {/* 3. Main Data Table (ဒေတာတွေကို Row တစ်ခုချင်းစီ Focus လုပ်ရလွယ်စေရန်) */}
                <div className="bg-white rounded-xl border border-slate-100 overflow-hidden">
                    <table className="w-full">
                        <thead>
                            <tr className="border-b border-slate-100 bg-slate-50">
                                <th className="px-10 py-4 text-sm font-bold text-slate-500 uppercase tracking-wider">Business</th>
                                <th className="px-10 py-4 text-sm font-bold text-slate-500 uppercase tracking-wider text-right">Profit / Loss</th>
                                <th className="w-24"></th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                            {resultData.length > 0 ? (
                                resultData.map((result) => (
                                    <tr key={result.id} className="group hover:bg-slate-50/80 transition-all cursor-pointer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setIsSaveFormVisible(true);
                                            setGameTypeDetailData(result);
                                        }}>
                                        <td className="px-10 py-3">
                                            <div className="flex items-center gap-4">
                                                <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 font-bold text-xs group-hover:bg-blue-400 group-hover:text-white transition-colors">
                                                    <TbCreditCard size={20} className="text-current" />
                                                </div>
                                                <span className="font-bold text-slate-700 tracking-tight group-hover:text-blue-500">{result?.gameType}</span>
                                            </div>
                                        </td>
                                        <td className="px-10 py-3 text-right">
                                            <div className="flex flex-col items-end">
                                                <span className={`text-base font-black ${result.total < 0 ? 'text-red' : 'text-emerald-600'}`}>
                                                    {result.total < 0 ? '' : '+'}{Number(result.total).toLocaleString()}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="px-6">
                                            <div className="flex justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                                <div className="p-2 bg-blue-50 text-blue-600 rounded-full">
                                                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="py-32 text-center text-slate-400">
                                        <div className="flex flex-col items-center gap-3">
                                            <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center opacity-50">
                                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
                                            </div>
                                            <p className="text-sm font-medium italic">No performance data for this period.</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <Copier
                    isSaveFormVisible={isSaveFormVisible}
                    onClick={() => setIsSaveFormVisible(!isSaveFormVisible)}
                    startDate={startDate}
                    endDate={endDate}
                    gameTypeDetailData={gameTypeDetailData}
                    fromDateToDate={""}
                />
            </div>
        </div>
    )
}

export default ProfitSharingForAll